import { useTranslation } from '../store';

const LoadingError = ({ message }: { message?: string }) => {
  const { t } = useTranslation();

  return (
    <div className="tab-content">
        <div className="error">{message || t('errorLoading')}</div>
    </div>
  );
};

export default LoadingError;